import { Component, OnInit} from '@angular/core';
import { PersonalService } from '../../../services/personal.service';
import { DireccionesPersonalService } from '../../../services/direcciones-personal.service';
import { FamiliaresService } from '../../../services/familiares.service';
import { InfoIdentidadService } from '../../../services/info-identidad.service';
import { DatosFechasService } from '../../../services/datos-fechas.service';
import { AfiliacionesService } from '../../../services/afiliaciones.service';
import { ContratoService } from '../../../services/datos-contratos.service';
import { DatosBancosService } from '../../../services/datos-bancos.service';
import { SueldoBasicoService } from '../../../services/sueldo-basico.service';
import { NovedadesMesService } from '../../../services/novedades-mes.service';
import { NovedadesPeriodoService } from '../../../services/novedades-periodo.service';
import { NominasEspecialesService } from '../../../services/nominas-especiales.service';
import { IndemnizacionService } from '../../../services/indemnizacion.service';
import { HorariosTrabajoService } from '../../../services/horarios-trabajo.service';
import { NovedadesTiemposService } from '../../../services/novedades-tiempos.service';
import { AusentismosService } from '../../../services/ausentismos.service';
import { ContingentesService } from '../../../services/contingentes.service';
import { ProvinciaService } from '../../../services/provincia.service';
import { PlanHorarioReglasService } from '../../../services/plan-horario-reglas.service';
import { CodigosNominaService } from '../../../services/codigosNomina.service';
import { ConfigDataService } from '../../../services/config-data.service';
import { UnidadesTiempoService } from '../../../services/unidades-tiempo.service';
import { ClaseAusentismoService } from '../../../services/clase-ausentismo.service';
import { ResuLiquidacionService } from '../../../services/resu_liquidacion.service';
import { DatosOrganizativosService } from '../../../services/datosOrganizativos.service';
import { GruposLiquidacionService } from '../../../services/gruposLiquidacion.service';
import { PeriodoDetService } from '../../../services/periodoDet.service';
import { BasesService } from '../../../services/bases.service';
import { AcumuladorService } from '../../../services/acumulador.service';
import { PromediosService } from '../../../services/promedios.service';
import { ConstanteService } from '../../../services/constante.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErroresService } from '../../../core/services/errores.service';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';
import { MomentSetService } from '../../../core/services/moment-set.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-importacion-datos',
  templateUrl: './importacion-datos.component.html',
  styleUrls: ['./importacion-datos.component.css']
})

export class ImportacionDatosComponent implements OnInit{

  tituloTabla: string = "";
  rowsExport: any[] = [];
  registros: any[] = [];
  columns: string[] = []; // Columnas generadas dinámicamente
  showDetails: boolean = false;
  MensajeError: string;
  Invalido: boolean;
  btnImport: boolean = false;
  bImport: string = "E"
  
  dropdownOptions: { codigo: string, descripcion: string }[] = [];
  selectedValue: { codigo: string, descripcion: string } | null = null;
  habilita: boolean = false;
  habilitaTodo: boolean = false;

  personalList: any;
  clasesDireccionList: any;
  paisesList: any;
  provinciasList: any;
  clasesFamiliarList: any;
  sexosList: any;
  nacionalidadesList: any;
  clasesDocList: any;
  estadoCivilList: any;
  clasesFechaList: any;
  clasesAfiliacionList: any;
  clasesContratosList: any;
  bancoList: any;
  monedasList: any;
  pagoList: any;
  estructuraSalariales: any;
  nivelList: any;
  subnivelList: any;
  unidadesList: any;
  motivosList: any;  
  motivosBajaList: any;
  reglasList: any;
  unidadesTiempoList: any;
  claseAusentismoList: any;
  claseContingenteList: any;
  codigoNominaList: any;
  tipoEvaluacionList: any;
  datosOrgList: any;
  gruposLiqList: any;
  periodosList: any;
  basesList: any;
  acumuladoresList: any;
  promediosList: any;
  constantesList: any;

  public constructor( private personalService: PersonalService,
                      private direccionesService: DireccionesPersonalService,
                      private familiaresService: FamiliaresService,
                      private infoIdentidadService: InfoIdentidadService,
                      private datosFechasService: DatosFechasService,
                      private afiliacionesService: AfiliacionesService,
                      private contratosService: ContratoService,
                      private datosBancoService: DatosBancosService,
                      private sueldoBasicoService: SueldoBasicoService,
                      private novedadesFijasService: NovedadesMesService,
                      private novedadesPeriodoService: NovedadesPeriodoService,
                      private nominasEspecialesService: NominasEspecialesService,
                      private indemnizacionService: IndemnizacionService,
                      private horariosTrabajoService: HorariosTrabajoService,
                      private novedadesTiempoService: NovedadesTiemposService,
                      private ausentismosService: AusentismosService,
                      private contingentesService: ContingentesService,
                      private provinciaService: ProvinciaService,
                      private planHorarioReglasService: PlanHorarioReglasService,
                      private codigosNominaService: CodigosNominaService,
                      private configDataSrv: ConfigDataService,
                      private unidadesTiempoService: UnidadesTiempoService,
                      private ausentismoSrv: ClaseAusentismoService,
                      private liquidacionSrv: ResuLiquidacionService,
                      private datosOrgServ: DatosOrganizativosService,
                      private gruposLiqServ: GruposLiquidacionService,
                      private periodoServ: PeriodoDetService,
                      private baseServ: BasesService,
                      private acumuladorServ: AcumuladorService,
                      private promedioServ: PromediosService,
                      private constanteServ: ConstanteService,
                      private erroresService: ErroresService,
                      private dialog: MatDialog,
                      private snackBar: MatSnackBar,
                      private momentService: MomentSetService) 
  {
  }
  
  public ngOnInit():any {
  
    this.verPermiso();
    
    this.personalService.getAll().subscribe(data =>{ this.personalList = data });
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    
    // if (permisos.includes("Alta Persona Sociedad")) this.dropdownOptions.push("Personal");

    if (permisos.includes("Editar Direcciones")) this.dropdownOptions.push({ codigo: 'Datos Básicos', descripcion: 'Direcciones' });
    if (permisos.includes("Editar Familiares")) this.dropdownOptions.push({ codigo: 'Datos Básicos', descripcion: 'Familiares' });
    if (permisos.includes("Editar Info Identidad")) this.dropdownOptions.push({ codigo: 'Datos Básicos', descripcion: 'Info Identidad' });
    if (permisos.includes("Editar Datos Fechas")) this.dropdownOptions.push({ codigo: 'Datos Básicos', descripcion: 'Datos Fechas' });
    if (permisos.includes("Editar Afiliaciones")) this.dropdownOptions.push({ codigo: 'Datos Básicos', descripcion: 'Afiliaciones' });
    if (permisos.includes("Editar Contratos")) this.dropdownOptions.push({ codigo: 'Datos Básicos', descripcion: 'Contratos' });
    
    if (permisos.includes("Editar Datos Bancarios")) this.dropdownOptions.push({ codigo: 'Datos de Nómina', descripcion: 'Datos Bancarios' });
    if (permisos.includes("Editar Sueldo Basico")) this.dropdownOptions.push({ codigo: 'Datos de Nómina', descripcion: 'Sueldo Básico' });
    if (permisos.includes("Editar Novedades Fijas")) this.dropdownOptions.push({ codigo: 'Datos de Nómina', descripcion: 'Novedades Fijas' });
    if (permisos.includes("Editar Novedades Periodo")) this.dropdownOptions.push({ codigo: 'Datos de Nómina', descripcion: 'Novedades Período' });
    if (permisos.includes("Editar Estado Nomina")) this.dropdownOptions.push({ codigo: 'Datos de Nómina', descripcion: 'Estado Nómina' });
    if (permisos.includes("Editar Nominas Especiales")) this.dropdownOptions.push({ codigo: 'Datos de Nómina', descripcion: 'Nóminas Especiales' });
    if (permisos.includes("Editar Indemnizacion")) this.dropdownOptions.push({ codigo: 'Datos de Nómina', descripcion: 'Indemnización' });
    
    if (permisos.includes("Editar Horarios de Trabajo")) this.dropdownOptions.push({ codigo: 'Datos de Tiempos', descripcion: 'Horarios de Trabajo' });
    if (permisos.includes("Editar Novedades Tiempos")) this.dropdownOptions.push({ codigo: 'Datos de Tiempos', descripcion: 'Novedades Tiempos' });
    if (permisos.includes("Editar Ausentismos")) this.dropdownOptions.push({ codigo: 'Datos de Tiempos', descripcion: 'Ausentismos' });
    if (permisos.includes("Editar Contingentes")) this.dropdownOptions.push({ codigo: 'Datos de Tiempos', descripcion: 'Contingentes' });

    if (permisos.includes("Liquidar")) this.dropdownOptions.push({ codigo: 'Datos de Liquidación', descripcion: 'Liquidaciones' });
    
    //Por ahora no se pidió
    // if (permisos.includes("Editar Datos Organizativos")) this.dropdownOptions.push({ codigo: 'Datos Básicos', descripcion: 'Datos Organizativos' });
    // if (permisos.includes("Editar Datos IIGG")) this.dropdownOptions.push({ codigo: 'Datos Legales', descripcion: 'Datos IIGG' });
    // if (permisos.includes("Editar Deducciones IIGG")) this.dropdownOptions.push({ codigo: 'Datos Legales', descripcion: 'Deducciones IIGG' });
    // if (permisos.includes("Editar Otro Empleador")) this.dropdownOptions.push({ codigo: 'Datos Legales', descripcion: 'Otro Empleador' });
    // if (permisos.includes("Editar Seguridad Social")) this.dropdownOptions.push({ codigo: 'Datos Legales', descripcion: 'Seguridad Social' });
  }

  onSubmit(){}

  getCellStyle(column: string) {
    const style: any = {};
    if (column === 'errores') {
      style['width'] = '200px';
    }
    if (this.isDateColumn(column)) {
      style['text-align'] = 'center';
    }
    return style;
  }

  isDateColumn(column: string): boolean {
    let esFecha = false;
    if (['fecha','desde','hasta','inicioLiquidacion','finLiquidacion','fechafinC','fechaFinPrueba',
         'fechaEvento','fechaEmision','fechaValidez','liquidarDesde','liquidarHasta',
         'fechaNacimiento','presentacionCertificado','ultimaLiquidacion',
         'retroactividad'].includes(column)) {
      esFecha = true;
    }
    return esFecha;
  }

  onClearOpcion(borra): void
  {
    this.tituloTabla = "";
    this.habilita = false;
    this.habilitaTodo = false;
    this.rowsExport = [];
    this.registros = [];
    this.columns = [];
    this.btnImport = false;
    if (borra) this.selectedValue = null;
    this.showDetails = false;
  }

  async onChangeOpcion(event) 
  {
    this.onClearOpcion(false);
    if (this.selectedValue != null) 
    {
      this.tituloTabla = this.selectedValue.descripcion;    
      this.btnImport = true;
    }
    
    let muestra = true;
    let codigosNominas = false;
    let datosOrganizativos = false;

    switch ( this.tituloTabla ) {
      case 'Direcciones':
        await this.configDataSrv.getDatosDirecciones().subscribe(
          data => {
            this.clasesDireccionList=data["ClaseDireccion"];
            this.paisesList=data["Paises"];
          });
        await this.provinciaService.getAll().subscribe(data => {this.provinciasList = data});        
        this.rowsExport = await this.direccionesService.getFormatoImportacion();        
        break;
      case 'Familiares':
        await this.configDataSrv.getDatosFamiliares().subscribe(
          data => {
            this.clasesFamiliarList=data["ClaseFamiliar"];
            this.sexosList=data["Sexos"];
            this.paisesList=data["Paises"];
            this.nacionalidadesList=data["Nacionalidad"];
            this.clasesDocList=data["ClaseDocumentos"];
            this.estadoCivilList=data["EstadoCivil"];
          });        
        this.rowsExport = await this.familiaresService.getFormatoImportacion();        
        break;
      case 'Info Identidad':
        await this.configDataSrv.getDatosInfoIdentidad().subscribe(
          data => {
            this.paisesList=data["Paises"];
            this.clasesDocList=data["ClaseDocumentos"];
          });        
        this.rowsExport = await this.infoIdentidadService.getFormatoImportacion();        
        break;
      case 'Datos Fechas':
        await this.configDataSrv.getDatosFechas().subscribe(
          data => {
            this.clasesFechaList=data;
          });        
        this.rowsExport = await this.datosFechasService.getFormatoImportacion();        
        break;
      case 'Afiliaciones':
        await this.configDataSrv.getDatosAfiliaciones().subscribe(
          data => {
            this.clasesAfiliacionList=data;
          });        
        this.rowsExport = await this.afiliacionesService.getFormatoImportacion();        
        break;
      case 'Contratos':
        await this.configDataSrv.getComboContratos().subscribe(
          data => {
            this.clasesContratosList=data;
          });        
        this.rowsExport = await this.contratosService.getFormatoImportacion();        
        break;
      case 'Datos Bancarios':
        await this.configDataSrv.GetBancos().subscribe(
          data => {
            this.bancoList=data["Bancos"];
            this.monedasList=data["Monedas"];
            this.pagoList = data["ViaPago"];
          });        
        this.rowsExport = await this.datosBancoService.getFormatoImportacion();        
        break;
      case 'Sueldo Básico':
        await this.configDataSrv.getSueldos().subscribe(
          data => {
            this.nivelList=data["Niveles"];
            this.subnivelList=data["SubNiveles"];
            this.estructuraSalariales=data["EstructuraSalarial"];
          });      
        // await this.sueldoBasicoService.getEstructuraSalarial().subscribe(data => {this.estructuraSalariales = data});        
        this.rowsExport = await this.sueldoBasicoService.getFormatoImportacion();        
        break;
      case 'Novedades Fijas':
        await this.configDataSrv.getDatosNominas().subscribe(
          data => {
            this.monedasList=data["Monedas"];
            this.unidadesList=data["UnidadesMedidas"];
          });
        codigosNominas = true;
        this.rowsExport = await this.novedadesFijasService.getFormatoImportacion();        
        break;
      case 'Novedades Período':
        await this.configDataSrv.getDatosNominas().subscribe(
          data => {
            this.monedasList=data["Monedas"];
            this.unidadesList=data["UnidadesMedidas"];
          });
        codigosNominas = true;
        this.rowsExport = await this.novedadesPeriodoService.getFormatoImportacion();        
        break;
      case 'Estado Nómina':
        this.rowsExport = await this.personalService.getFormatoImportacionEstado();        
        break;
      case 'Nóminas Especiales':
        await this.configDataSrv.getDatosNominas().subscribe(
          data => {
            this.monedasList=data["Monedas"];
            this.motivosList=data["MotivoNominaEspecial"];
          });
        codigosNominas = true;
        this.rowsExport = await this.nominasEspecialesService.getFormatoImportacion();        
        break;
      case 'Indemnización':
        await this.configDataSrv.getDatosIndemnizaciones().subscribe(
          data => {
            this.monedasList=data["Monedas"];
            this.motivosBajaList=data["MotivoBaja"];
          });
        this.rowsExport = await this.indemnizacionService.getFormatoImportacion();        
        break;
      case 'Horarios de Trabajo':
        await this.planHorarioReglasService.getAll().subscribe(data =>{this.reglasList = data});    
        this.tipoEvaluacionList = await this.horariosTrabajoService.getTiposEvaluacion();    
        this.rowsExport = await this.horariosTrabajoService.getFormatoImportacion();        
        break;
      case 'Novedades Tiempos':
        await this.configDataSrv.getDatosNominas().subscribe(
          data => {
            this.unidadesList=data["UnidadesMedidas"];
          });
        codigosNominas = true;
        this.rowsExport = await this.novedadesTiempoService.getFormatoImportacion();        
        break;
      case 'Ausentismos':
        await this.configDataSrv.getDatosAusentismos().subscribe(
          data => {
            this.unidadesTiempoList=data["UnidadesTiempo"];
          });
        codigosNominas = true;      
        await this.ausentismoSrv.getAll().subscribe(codigos => { this.claseAusentismoList = codigos});
        this.rowsExport = await this.ausentismosService.getFormatoImportacion();        
        break;
      case 'Contingentes':
        await this.configDataSrv.getDatosContingentes().subscribe(
          data => {
            this.claseContingenteList=data["ClaseContingentes"];
          });        
        this.rowsExport = await this.contingentesService.getFormatoImportacion();        
        break;
      case 'Liquidaciones':
        codigosNominas = true;
        datosOrganizativos = true;
        await this.gruposLiqServ.getAll().subscribe(data => { this.gruposLiqList = data});
        await this.periodoServ.getAll().subscribe(data => { this.periodosList = data});
        await this.baseServ.getAll().subscribe(data => { this.basesList = data});
        await this.acumuladorServ.getAll().subscribe(data => { this.acumuladoresList = data});
        await this.promedioServ.getAll().subscribe(data => { this.promediosList = data});
        await this.constanteServ.getAll().subscribe(data => { this.constantesList = data});
        this.rowsExport = await this.liquidacionSrv.getFormatoImportacion();        
        break;
      default: 
        muestra = false;
        break;
    }

    if (codigosNominas)
    {
      await this.codigosNominaService.getAll().subscribe(
        codigos => 
      { 
        codigos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta); 
        });

        this.codigoNominaList = codigos;
      });
    }   
    if (datosOrganizativos)
    {
      await this.datosOrgServ.getAll().subscribe(
        datosO => 
      { 
        datosO.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta); 
        });

        this.datosOrgList = datosO;
      });
    }   

    this.registros = this.rowsExport;
    // Generar las columnas dinámicamente basadas en la primera entrada de registros
    if (this.registros.length > 0) this.columns = Object.keys(this.registros[0]);
    const errorIndex = this.columns.indexOf('errores');  
    if (errorIndex !== -1) this.columns.splice(errorIndex, 1);
    // this.showDetails = muestra;
  }

  import(rowsImport){
    this.registros = [];
    this.habilita = true;
    this.habilitaTodo = true;

    rowsImport.forEach((currentValue,index,arr) => {
      let errores = this.validarImport(currentValue);
      if (errores.length > 0) this.habilitaTodo = false;
      
      currentValue.errores = errores;
      this.registros.push(currentValue);      
    });

    //Mostrar detalle y boton de confirmacion
    this.showDetails = true;    
  }  

  validarImport(registro) : string[]
  {
    let errores = [];

    switch ( this.tituloTabla ) {
      case 'Direcciones':
        errores = this.validacionesDireccion(registro);
        break;
      case 'Familiares':
        errores = this.validacionesFamiliares(registro);
        break;
      case 'Info Identidad':
        errores = this.validacionesInfoIdentidad(registro);
        break;
      case 'Datos Fechas':
        errores = this.validacionesDatosFechas(registro);
        break;
      case 'Afiliaciones':
        errores = this.validacionesAfiliaciones(registro);
        break;
      case 'Contratos':
        errores = this.validacionesContratos(registro);
        break;
      case 'Datos Bancarios':
        errores = this.validacionesDatosBancarios(registro);
        break;
      case 'Sueldo Básico':
        errores = this.validacionesSueldoBasico(registro);
        break;
      case 'Novedades Fijas':
        errores = this.validacionesNovedadesFijas(registro);
        break;
      case 'Novedades Período':
        errores = this.validacionesNovedadesPeriodo(registro);
        break;
      case 'Estado Nómina':
        errores = this.validacionesEstadoNomina(registro);
        break;
      case 'Nóminas Especiales':
        errores = this.validacionesNominasEspeciales(registro); 
        break;
      case 'Indeminzación':
        errores = this.validacionesIndemizacion(registro); 
        break;
      case 'Horarios de Trabajo':
        errores = this.validacionesHorariosTrabajo(registro); 
        break;
      case 'Novedades Tiempos':
        errores = this.validacionesNovedadesTiempos(registro); 
        break;
      case 'Ausentismos':
        errores = this.validacionesAusentismos(registro); 
        break;
      case 'Contingentes':
        errores = this.validacionesContingentes(registro); 
        break;
      case 'Liquidaciones':
        errores = this.validacionesLiquidaciones(registro); 
        break;
      default: 
        break;
    }

    return errores;
  }

  // #region validaciones
  validacionesGenerales(reg, opcion) : string[]
  {
    const errores = [];
    let index;

    if (!reg.personal || reg.personal == undefined || isNaN(reg.personal)) 
    {
      errores.push('El campo "personal" es obligatorio ingresar un número');
    }
    index = this.personalList.findIndex(x => x.code == reg.personal);
    if (index == -1)
    {
      errores.push('El campo "personal" no se corresponde a un Empleado válido' );
    }
    if (opcion == 'soloFecha')
    {
      if (!reg.fecha || reg.fecha == undefined || isNaN(Date.parse(reg.fecha)))
      {
        errores.push('El campo "fecha" es obligatorio ingresar una fecha' );
      }
    }
    else if (opcion == 'desdeHasta')
    {
      if (!reg.desde || reg.desde == undefined || isNaN(Date.parse(reg.desde)))
      {
        errores.push('El campo "desde" es obligatorio ingresar una fecha' );
      }
      if (!reg.hasta || reg.hasta == undefined || isNaN(Date.parse(reg.hasta))) 
      {
        errores.push('El campo "hasta" es obligatorio ingresar una fecha' );
      }
      if (Date.parse(reg.desde) > Date.parse(reg.hasta)) 
      {
        errores.push('El campo "hasta" es anterior al campo "desde"' );
      }
    }    

    return errores
  }

  validacionesDireccion(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    index = this.clasesDireccionList.findIndex(i => i.codigo == reg.clase);
    if (index == -1 )
    {
      errores.push('El campo "clase" no se corresponde a una Clase Dirección válida' );
    }
    if (!reg.calle || reg.calle == undefined) 
    {
      errores.push('El campo "calle" es obligatorio');
    }
    if (!reg.nro || reg.nro == undefined || isNaN(reg.nro)) 
    {
      errores.push('El campo "nro" es obligatorio ingresar un número');
    }
    if (!reg.localidad || reg.localidad == undefined) 
    {
      errores.push('El campo "localidad" es obligatorio');
    }
    if (!reg.codpos || reg.codpos == undefined || isNaN(reg.codpos)) 
    {
      errores.push('El campo "codpos" es obligatorio ingresar un número');
    }
    let pais;
    index = this.paisesList.findIndex(i => i.codigo == reg.pais);
    if (index == -1 )
    {
      errores.push('El campo "pais" no se corresponde a un País válido' );
    }
    else
    {
      pais = this.paisesList[index];
    }
    index = this.provinciasList.findIndex(i => i.codigo == reg.provincia);
    if (index == -1 )
    {
      errores.push('El campo "provincia" no se corresponde a una Provincia válida' );
    } else if (pais != undefined)
    {
      if (this.provinciasList[index].pais != pais.id )
      {
        errores.push('El campo "provincia" no pertenece al País' );
      }
    }
    if (!reg.telefono || reg.telefono == undefined) 
    {
      errores.push('El campo "telefono" es obligatorio');
    }

    return errores;
  }

  validacionesFamiliares(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;
    
    index = this.clasesFamiliarList.findIndex(i => i.codigo == reg.claseFamilia);
    if (index == -1 )
    {
      errores.push('El campo "claseFamilia" no se corresponde a una Clase Familiar válida' );
    }
    if (!reg.nombre || reg.nombre == undefined) 
    {
      errores.push('El campo "nombre" es obligatorio');
    }
    if (!reg.apellido || reg.apellido == undefined) 
    {
      errores.push('El campo "apellido" es obligatorio');
    }
    index = this.sexosList.findIndex(i => i.codigo == reg.sexo);
    if (index == -1 )
    {
      errores.push('El campo "sexo" no se corresponde a un Sexo válido' );
    }
    index = this.clasesDocList.findIndex(i => i.codigo == reg.claseDocumento);
    if (index == -1 )
    {
      errores.push('El campo "claseDocumento" no se corresponde a una Clase Documento válida' );
    }
    if (!reg.docNro || reg.docNro == undefined) 
    {
      errores.push('El campo "docNro" es obligatorio');
    }
    if (!reg.fechaNacimiento || reg.fechaNacimiento == undefined || isNaN(Date.parse(reg.fechaNacimiento)))
    {
      errores.push('El campo "fechaNacimiento" es obligatorio ingresar una fecha' );
    }
    index = this.paisesList.findIndex(i => i.codigo == reg.pais);
    if (index == -1 )
    {
      errores.push('El campo "pais" no se corresponde a un País válido' );
    }
    index = this.nacionalidadesList.findIndex(i => i.codigo == reg.nacionalidad);
    if (index == -1 )
    {
      errores.push('El campo "nacionalidad" no se corresponde a una Nacionalidad válida' );
    }
    index = this.estadoCivilList.findIndex(i => i.codigo == reg.estadoCivil);
    if (index == -1 )
    {
      errores.push('El campo "estadoCivil" no se corresponde a un Estado Civil válido' );
    }
    if (!reg.celular || reg.celular == undefined) 
    {
      errores.push('El campo "celular" es obligatorio');
    }    
    if (!reg.email || reg.email == undefined) 
    {
      errores.push('El campo "email" es obligatorio');
    }
    if (reg.contactoEmergencia != '' && reg.contactoEmergencia != undefined && reg.contactoEmergencia != 'true' && reg.contactoEmergencia != 'false') 
    {
      errores.push('El campo "contactoEmergencia" solo admite valor true o false');
    }
    if (reg.discapacitado != '' && reg.discapacitado != undefined && reg.discapacitado != 'true' && reg.discapacitado != 'false') 
    {
      errores.push('El campo "discapacitado" solo admite valor true o false');
    }
    if (reg.discapacitado == 'true')
    {
      if (!reg.presentacionCertificado || reg.presentacionCertificado == undefined || isNaN(Date.parse(reg.presentacionCertificado)))
      {
        errores.push('El campo "presentacionCertificado" es obligatorio ingresar una fecha' );
      }
    }   

    return errores;
  }

  validacionesInfoIdentidad(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;
    
    index = this.clasesDocList.findIndex(i => i.codigo == reg.claseDocumento);
    if (index == -1 )
    {
      errores.push('El campo "claseDocumento" no se corresponde a una Clase Documento válida' );
    }
    if (!reg.docNro || reg.docNro == undefined) 
    {
      errores.push('El campo "docNro" es obligatorio');
    }
    if (!reg.fechaEmision || reg.fechaEmision == undefined || isNaN(Date.parse(reg.fechaEmision)))
    {
      errores.push('El campo "fechaEmision" es obligatorio ingresar una fecha' );
    }
    if (!reg.fechaValidez || reg.fechaValidez == undefined || isNaN(Date.parse(reg.fechaValidez)))
    {
      errores.push('El campo "fechaValidez" es obligatorio ingresar una fecha' );
    }
    if (!reg.lugarEmision || reg.lugarEmision == undefined) 
    {
      errores.push('El campo "lugarEmision" es obligatorio');
    }
    index = this.paisesList.findIndex(i => i.codigo == reg.paisEmisor);
    if (index == -1 )
    {
      errores.push('El campo "paisEmisor" no se corresponde a un País válido' );
    }
    if (!reg.nroEmision || reg.nroEmision == undefined) 
    {
      errores.push('El campo "nroEmision" es obligatorio');
    }    
    if (!reg.autoridad || reg.autoridad == undefined) 
    {
      errores.push('El campo "autoridad" es obligatorio');
    }

    return errores;
  }

  validacionesDatosFechas(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    index = this.clasesFechaList.findIndex(i => i.codigo == reg.claseFecha);
    if (index == -1 )
    {
      errores.push('El campo "claseFecha" no se corresponde a una Clase Fecha válida' );
    }
    if (!reg.fechaEvento || reg.fechaEvento == undefined || isNaN(Date.parse(reg.fechaEvento)))
    {
      errores.push('El campo "fechaEvento" es obligatorio ingresar una fecha' );
    }    

    return errores;
  }

  validacionesAfiliaciones(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    index = this.clasesAfiliacionList.findIndex(i => i.codigo == reg.claseAfiliaciones);
    if (index == -1 )
    {
      errores.push('El campo "claseAfiliaciones" no se corresponde a una Clase Afiliación válida' );
    }
    if (!reg.descripcion || reg.descripcion == undefined) 
    {
      errores.push('El campo "descripcion" es obligatorio');
    }    

    return errores;
  }

  validacionesContratos(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    index = this.clasesContratosList.findIndex(i => i.codigo == reg.claseContrato);
    if (index == -1 )
    {
      errores.push('El campo "claseContrato" no se corresponde a una Clase Contrato válida' );
    }
    if (!reg.fechafinC || reg.fechafinC == undefined || isNaN(Date.parse(reg.fechafinC)))
    {
      errores.push('El campo "fechafinC" es obligatorio ingresar una fecha' );
    }
    if (Date.parse(reg.fechafinC) > Date.parse(reg.hasta)) 
    {
      errores.push('El campo "hasta" es anterior al campo "fechafinC"' );
    }
    if (!reg.fechaFinPrueba || reg.fechaFinPrueba == undefined || isNaN(Date.parse(reg.fechaFinPrueba)))
    {
      errores.push('El campo "fechaFinPrueba" es obligatorio ingresar una fecha' );
    }
    if (Date.parse(reg.fechaFinPrueba) > Date.parse(reg.hasta)) 
    {
      errores.push('El campo "hasta" es anterior al campo "fechaFinPrueba"' );
    }    
    if (!reg.periodoPrueba || reg.periodoPrueba == undefined || isNaN(reg.periodoPrueba)) 
    {
      errores.push('El campo "periodoPrueba" es obligatorio ingresar un número');
    }
    if (!reg.horasMensuales || reg.horasMensuales == undefined || isNaN(reg.horasMensuales)) 
    {
      errores.push('El campo "horasMensuales" es obligatorio ingresar un número');
    }
    if (!reg.horasJornadaLaboral || reg.horasJornadaLaboral == undefined || isNaN(reg.horasJornadaLaboral)) 
    {
      errores.push('El campo "horasJornadaLaboral" es obligatorio ingresar un número');
    }

    return errores;
  }

  validacionesDatosBancarios(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    index = this.bancoList.findIndex(i => i.codigo == reg.banco);
    if (index == -1 )
    {
      errores.push('El campo "banco" no se corresponde a un Banco válido' );
    }
    if (!reg.cbu || reg.cbu == undefined ) 
    {
      errores.push('El campo "cbu" es obligatorio');
    }
    if (!reg.cuentaBancaria || reg.cuentaBancaria == undefined ) 
    {
      errores.push('El campo "cuentaBancaria" es obligatorio');
    }
    index = this.pagoList.findIndex(i => i.codigo == reg.viaPago);
    if (index == -1 )
    {
      errores.push('El campo "viaPago" no se corresponde a una Vía de Pago válida' );
    }
    index = this.monedasList.findIndex(i => i.codigo == reg.moneda);
    if (index == -1 )
    {
      errores.push('El campo "moneda" no se corresponde a una Moneda válida' );
    }
        
    return errores;
  }

  validacionesSueldoBasico(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    index = this.estructuraSalariales.findIndex(i => i.codigo == reg.estructuraSalarialId);
    if (index == -1 )
    {
      errores.push('El campo "estructuraSalarialId" no se corresponde a una Estructura Salarial válida' );
    }
    index = this.nivelList.findIndex(i => i.codigo == reg.nivel);
    if (index == -1 )
    {
      errores.push('El campo "nivel" no se corresponde a un Nivel válido' );
    }
    index = this.subnivelList.findIndex(i => i.codigo == reg.subNivel);
    if (index == -1 )
    {
      errores.push('El campo "subNivel" no se corresponde a un Subnivel válido' );
    }
        
    return errores;
  }

  validacionesNovedadesFijas(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'soloFecha');
    let index;

    if (reg.quincena && reg.quincena == undefined ) 
    {
      if (isNaN(reg.quincena))
      {
        errores.push('El campo "quincena" debe ingresar un número');
      }
    }
    let nomina;
    index = this.codigoNominaList.findIndex(i => i.codigo == reg.codigosNomina 
                                              && Date.parse(i.desde) <= Date.parse(reg.fecha) 
                                              && Date.parse(i.hasta) >= Date.parse(reg.fecha));
    if (index == -1 )
    {
      errores.push('El campo "codigosNomina" no se corresponde a un Código Nómina válido' );
    }
    else
    {
      nomina = this.codigoNominaList[index];
      if (nomina.tipoCarga == 2)
      {
        //Cantidad obligatoria
        if (!reg.cantidad || reg.cantidad == undefined || isNaN(reg.cantidad) ) 
        {
          errores.push('El campo "cantidad" es obligatorio ingresar un número');
        }
      }
      else if (nomina.tipoCarga == 1)
      {
        //Importe y moneda obligatoria
        if (!reg.importe || reg.importe == undefined || isNaN(reg.importe) ) 
        {
          errores.push('El campo "importe" es obligatorio ingresar un número');
        }
        index = this.monedasList.findIndex(i => i.codigo == reg.moneda);
        if (index == -1 )
        {
          errores.push('El campo "moneda" no se corresponde a una Moneda válida' );
        }
      }
      else if (nomina.tipoCarga == 3)
      {
        //Todo obligatorio
        if (!reg.cantidad || reg.cantidad == undefined || isNaN(reg.cantidad) ) 
        {
          errores.push('El campo "cantidad" es obligatorio ingresar un número');
        }
        if (!reg.importe || reg.importe == undefined || isNaN(reg.importe) ) 
        {
          errores.push('El campo "importe" es obligatorio ingresar un número');
        }
        index = this.monedasList.findIndex(i => i.codigo == reg.moneda);
        if (index == -1 )
        {
          errores.push('El campo "moneda" no se corresponde a una Moneda válida' );
        }
      }
      if (nomina.novedadesMes != true)
      {
        errores.push('El campo "codigosNomina" no está habilitado para Novedades Fijas' );
      }
    }
        
    return errores;
  }

  validacionesNovedadesPeriodo(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    if (reg.quincena && reg.quincena == undefined ) 
    {
      if (isNaN(reg.quincena))
      {
        errores.push('El campo "quincena" debe ingresar un número');
      }
    }
    let nomina;
    index = this.codigoNominaList.findIndex(i => i.codigo == reg.codigoNomina 
                                              && Date.parse(i.desde) <= Date.parse(reg.hasta) 
                                              && Date.parse(i.hasta) >= Date.parse(reg.desde));
    if (index == -1 )
    {
      errores.push('El campo "codigoNomina" no se corresponde a un Código Nómina válido' );
    }
    else
    {
      nomina = this.codigoNominaList[index];
      if (nomina.tipoCarga == 2)
      {
        //Cantidad obligatoria
        if (!reg.cantidad || reg.cantidad == undefined || isNaN(reg.cantidad) ) 
        {
          errores.push('El campo "cantidad" es obligatorio ingresar un número');
        }
      }
      else if (nomina.tipoCarga == 1)
      {
        //Importe y moneda obligatoria
        if (!reg.importe || reg.importe == undefined || isNaN(reg.importe) ) 
        {
          errores.push('El campo "importe" es obligatorio ingresar un número');
        }
        index = this.monedasList.findIndex(i => i.codigo == reg.moneda);
        if (index == -1 )
        {
          errores.push('El campo "moneda" no se corresponde a una Moneda válida' );
        }
      }
      else if (nomina.tipoCarga == 3)
      {
        //Todo obligatorio
        if (!reg.cantidad || reg.cantidad == undefined || isNaN(reg.cantidad) ) 
        {
          errores.push('El campo "cantidad" es obligatorio ingresar un número');
        }
        if (!reg.importe || reg.importe == undefined || isNaN(reg.importe) ) 
        {
          errores.push('El campo "importe" es obligatorio ingresar un número');
        }
        index = this.monedasList.findIndex(i => i.codigo == reg.moneda);
        if (index == -1 )
        {
          errores.push('El campo "moneda" no se corresponde a una Moneda válida' );
        }
      }
      if (nomina.novedadesPeriodo != true)
      {
        errores.push('El campo "codigosNomina" no está habilitado para Novedades Período' );
      }
    }
        
    return errores;
  }

  validacionesEstadoNomina(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'ninguna');
    let index;

    if (reg.bloqueado != '' && reg.bloqueado != undefined && reg.bloqueado != 'true' && reg.bloqueado != 'false') 
    {
      errores.push('El campo "bloqueado" solo admite valor true o false');
    }
    if (!reg.liquidarDesde || reg.liquidarDesde == undefined || isNaN(Date.parse(reg.liquidarDesde)))
    {
      errores.push('El campo "liquidarDesde" es obligatorio ingresar una fecha' );
    }
    if (!reg.liquidarHasta || reg.liquidarHasta == undefined || isNaN(Date.parse(reg.liquidarHasta))) 
    {
      errores.push('El campo "liquidarHasta" es obligatorio ingresar una fecha' );
    }
    if (Date.parse(reg.liquidarDesde) > Date.parse(reg.liquidarHasta)) 
    {
      errores.push('El campo "liquidarHasta" es anterior al campo "liquidarDesde"' );
    }
    if (reg.ultimaLiquidacion && reg.ultimaLiquidacion == undefined ) 
    {
      if (isNaN(Date.parse(reg.ultimaLiquidacion)))
      {
        errores.push('El campo "ultimaLiquidacion" debe ingresar una fecha');
      }
    }
    if (reg.retroactividad && reg.retroactividad == undefined ) 
    {
      if (isNaN(Date.parse(reg.retroactividad)))
      {
        errores.push('El campo "retroactividad" debe ingresar una fecha');
      }
    }

    return errores;
  }

  validacionesNominasEspeciales(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'soloFecha');
    let index;

    index = this.motivosList.findIndex(i => i.codigo == reg.motivoNominaEspecial);
    if (index == -1 )
    {
      errores.push('El campo "motivoNominaEspecial" no se corresponde a un Motivo válido' );
    }
    let nomina;
    index = this.codigoNominaList.findIndex(i => i.codigo == reg.codigosNomina 
                                              && Date.parse(i.desde) <= Date.parse(reg.fecha) 
                                              && Date.parse(i.hasta) >= Date.parse(reg.fecha));
    if (index == -1 )
    {
      errores.push('El campo "codigosNomina" no se corresponde a un Código Nómina válido' );
    }
    else
    {
      nomina = this.codigoNominaList[index];
      if (nomina.tipoCarga == 2)
      {
        //Cantidad obligatoria
        if (!reg.cantidad || reg.cantidad == undefined || isNaN(reg.cantidad) ) 
        {
          errores.push('El campo "cantidad" es obligatorio ingresar un número');
        }
      }
      else if (nomina.tipoCarga == 1)
      {
        //Importe y moneda obligatoria
        if (!reg.importe || reg.importe == undefined || isNaN(reg.importe) ) 
        {
          errores.push('El campo "importe" es obligatorio ingresar un número');
        }
        index = this.monedasList.findIndex(i => i.codigo == reg.moneda);
        if (index == -1 )
        {
          errores.push('El campo "moneda" no se corresponde a una Moneda válida' );
        }
      }
      else if (nomina.tipoCarga == 3)
      {
        //Todo obligatorio
        if (!reg.cantidad || reg.cantidad == undefined || isNaN(reg.cantidad) ) 
        {
          errores.push('El campo "cantidad" es obligatorio ingresar un número');
        }
        if (!reg.importe || reg.importe == undefined || isNaN(reg.importe) ) 
        {
          errores.push('El campo "importe" es obligatorio ingresar un número');
        }
        index = this.monedasList.findIndex(i => i.codigo == reg.moneda);
        if (index == -1 )
        {
          errores.push('El campo "moneda" no se corresponde a una Moneda válida' );
        }
      }
      if (nomina.nominaEspecial != true)
      {
        errores.push('El campo "codigosNomina" no está habilitado para Nóminas Especiales' );
      }
    }
        
    return errores;
  }

  validacionesIndemizacion(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'soloFecha');
    let index;

    index = this.motivosBajaList.findIndex(i => i.codigo == reg.motivoBaja);
    if (index == -1 )
    {
      errores.push('El campo "motivoBaja" no se corresponde a un Motivo válido' );
    }
    
    return errores;
  }

  validacionesHorariosTrabajo(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    index = this.reglasList.findIndex(i => i.codigo == reg.reglaHt);
    if (index == -1 )
    {
      errores.push('El campo "reglaHt" no se corresponde a una Regla Plan Horario válida' );
    }
    if (!reg.porcentajeAsignacion || reg.porcentajeAsignacion == undefined || isNaN(reg.porcentajeAsignacion))
    {
      errores.push('El campo "porcentajeAsignacion" es obligatorio ingresar un número' );
    }
    index = this.tipoEvaluacionList.findIndex(i => i.id == reg.tipoEvaluacion);
    if (index == -1 )
    {
      errores.push('El campo "tipoEvaluacion" no se corresponde a un Tipo de Evaluación válida' );
    }

    return errores;
  }

  validacionesNovedadesTiempos(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'soloFecha');
    let index;

    let nomina;
    index = this.codigoNominaList.findIndex(i => i.codigo == reg.codigosNomina 
                                              && Date.parse(i.desde) <= Date.parse(reg.fecha) 
                                              && Date.parse(i.hasta) >= Date.parse(reg.fecha));
    if (index == -1 )
    {
      errores.push('El campo "codigosNomina" no se corresponde a un Código Nómina válido' );
    }
    else
    {
      nomina = this.codigoNominaList[index];
      if (nomina.tipoCarga == 2)
      {
        //Cantidad obligatoria
        if (!reg.cantidad || reg.cantidad == undefined || isNaN(reg.cantidad) ) 
        {
          errores.push('El campo "cantidad" es obligatorio ingresar un número');
        }
      }
      else if (nomina.tipoCarga == 1)
      {
        //Importe y moneda obligatoria
        if (!reg.importe || reg.importe == undefined || isNaN(reg.importe) ) 
        {
          errores.push('El campo "importe" es obligatorio ingresar un número');
        }
        index = this.monedasList.findIndex(i => i.codigo == reg.moneda);
        if (index == -1 )
        {
          errores.push('El campo "moneda" no se corresponde a una Moneda válida' );
        }
      }
      else if (nomina.tipoCarga == 3)
      {
        //Todo obligatorio
        if (!reg.cantidad || reg.cantidad == undefined || isNaN(reg.cantidad) ) 
        {
          errores.push('El campo "cantidad" es obligatorio ingresar un número');
        }
        if (!reg.importe || reg.importe == undefined || isNaN(reg.importe) ) 
        {
          errores.push('El campo "importe" es obligatorio ingresar un número');
        }
        index = this.monedasList.findIndex(i => i.codigo == reg.moneda);
        if (index == -1 )
        {
          errores.push('El campo "moneda" no se corresponde a una Moneda válida' );
        }
      }
      if (nomina.novedadesTiempos != true)
      {
        errores.push('El campo "codigosNomina" no está habilitado para Nóminas Especiales' );
      }
    }
        
    return errores;
  }

  validacionesAusentismos(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    index = this.claseAusentismoList.findIndex(i => i.codigo == reg.claseAusentismo);
    if (index == -1 )
    {
      errores.push('El campo "claseAusentismo" no se corresponde a una Clase Ausentismo válida' );
    }
    else
    {
      let clase = this.claseAusentismoList[index];
      if (clase.unidadTiempo == 3)
      {
        //Hora obligatoria
        if (!reg.horaDesde || reg.horaDesde == undefined ) 
        {
          errores.push('El campo "horaDesde" es obligatorio ingresar');
        }
        if (!reg.horaHasta || reg.horaHasta == undefined ) 
        {
          errores.push('El campo "horaHasta" es obligatorio ingresar');
        }
      }
      else
      {
        reg.horaDesde = '';
        reg.horaHasta = '';
      }
    }

    return errores;
  }

  validacionesContingentes(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'desdeHasta');
    let index;

    index = this.claseContingenteList.findIndex(i => i.codigo == reg.claseContingente);
    if (index == -1 )
    {
      errores.push('El campo "claseContingente" no se corresponde a una Clase Contingente válida' );
    }
    if (!reg.inicioLiquidacion || reg.inicioLiquidacion == undefined || isNaN(Date.parse(reg.inicioLiquidacion)))
    {
      errores.push('El campo "inicioLiquidacion" es obligatorio ingresar una fecha' );
    }
    if (!reg.finLiquidacion || reg.finLiquidacion == undefined || isNaN(Date.parse(reg.finLiquidacion))) 
    {
      errores.push('El campo "finLiquidacion" es obligatorio ingresar una fecha' );
    }
    if (Date.parse(reg.inicioLiquidacion) > Date.parse(reg.finLiquidacion)) 
    {
      errores.push('El campo "finLiquidacion" es anterior al campo "inicioLiquidacion"' );
    }    
    if (!reg.cantidad || reg.cantidad == undefined || isNaN(reg.cantidad))
    {
      errores.push('El campo "cantidad" es obligatorio ingresar un número' );
    }    

    return errores;
  }
  validacionesLiquidaciones(reg) : string[]
  {
    const errores = this.validacionesGenerales(reg, 'soloFecha');
    let index;
    let index2;

    index = this.personalList.findIndex(x => x.code == reg.personal);
    if (index != -1)
    {
      let empleado = this.personalList[index].id;
      //Buscar grupo de liquidacion
      index = this.datosOrgList.findIndex(i => i.personal == empleado
                                               && Date.parse(i.desde) <= Date.parse(reg.fecha) 
                                               && Date.parse(i.hasta) >= Date.parse(reg.fecha));

      if (index == -1)
      {
        errores.push('El personal no tiene definido Datos Organizativos para la fecha' );
      }
      else if (this.datosOrgList[index].grupoLiquidacion == null)
      {
        errores.push('El personal no tiene definido un Grupo de Liquidación' );
      }
      else
      {
        let grupo = this.datosOrgList[index].grupoLiquidacion;
        index = this.gruposLiqList.findIndex(i => i.id == grupo);
        if (index != -1)
        {
          let cabecera = this.gruposLiqList[index].periodoCab;
          index = this.periodosList.findIndex(i => i.periodoCabecera == cabecera
                                                   && Date.parse(i.fechaDd) <= Date.parse(reg.fecha) 
                                                   && Date.parse(i.fechaHh) >= Date.parse(reg.fecha));
          if (index == -1)
          {
            errores.push('El Grupo de Liquidación del Personal no tiene definido un Período para la fecha' );
          }
        }
      }                                             
    }

    if (!reg.tipo || reg.tipo == undefined || reg.tipo == '' ) 
    {
      errores.push('El campo "tipo" es obligatorio');
    }
    else if (reg.tipo == "Concepto" ) 
    {
      index = this.codigoNominaList.findIndex(i => i.codigo == reg.codigoNomina 
        && Date.parse(i.desde) <= Date.parse(reg.fecha) 
        && Date.parse(i.hasta) >= Date.parse(reg.fecha));
      if (index == -1 )
      {
      errores.push('El campo "codigoNomina" no se corresponde a un Código Nómina válido' );
      }
    }
    else if (reg.tipo == "Base" ) 
    {
      index = this.basesList.findIndex(i => i.codigo == reg.codigoNomina);
      if (index == -1 )
      {
      errores.push('El campo "codigoNomina" no se corresponde a una Base válida' );
      }
    }
    else if (reg.tipo == "Acumulador" ) 
    {
      index = this.acumuladoresList.findIndex(i => i.codigo == reg.codigoNomina);
      if (index == -1 )
      {
      errores.push('El campo "codigoNomina" no se corresponde a un Acumulador válido' );
      }
    }
    else if (reg.tipo == "Promedio" ) 
    {
      index = this.promediosList.findIndex(i => i.codigo == reg.codigoNomina);
      if (index == -1 )
      {
      errores.push('El campo "codigoNomina" no se corresponde a un Promedio válido' );
      }
    }
    else if (reg.tipo == "Constante" ) 
    {
      index = this.constantesList.findIndex(i => i.codigo == reg.codigoNomina);
      if (index == -1 )
      {
      errores.push('El campo "codigoNomina" no se corresponde a una Constante válida' );
      }
    }
    else
    {
      errores.push('El campo "tipo" no se corresponde a un tipo válido (Concepto, Base, Acumulador, Promedio, Constante)');
    }

    if (!reg.importe || reg.importe == undefined || isNaN(reg.importe) ) 
    {
      errores.push('El campo "importe" es obligatorio ingresar un número');
    }

    return errores;
  }
  // #endregion


  confirmar(): void
  {
    let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, 
    {
      width: '400px'
    });
    dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

    switch ( this.tituloTabla ) {
      case 'Liquidaciones':
        this.saveHistorial(this.registros);
        break;
      default:
        this.registros.forEach(async (currentValue, index, arr) => {
          if (currentValue.errores.length == 0) {
            this.confirmarImport(currentValue, index);
          }
        }); 
        break;
    }
    this.habilitaTodo = false;
    
    setTimeout(function ()
    {
      dialogProcesandoRef.close();
    });
    this.snackBar.open('Se procesaron ' + this.registros.length + ' registros.' , "OK", { duration: 10000 });
  }

  confirmarImport(registro, indice) : void
  {
    
    switch ( this.tituloTabla ) {
      case 'Direcciones':
        this.saveDireccion(registro, indice);
        break;
      case 'Familiares':
        this.saveFamiliares(registro, indice);
        break;
      case 'Info Identidad':
        this.saveInfoIdentidad(registro, indice);
        break;
      case 'Datos Fechas':
        this.saveDatosFechas(registro, indice);
        break;
      case 'Afiliaciones':
        this.saveAfiliaciones(registro, indice);
        break;
      case 'Contratos':
        this.saveContratos(registro, indice);
        break;
      case 'Datos Bancarios':
        this.saveDatosBancarios(registro, indice);
        break;
      case 'Sueldo Básico':
        this.saveSueldoBasico(registro, indice);
        break;
      case 'Novedades Fijas':
        this.saveNovedadesFijas(registro, indice);
        break;
      case 'Novedades Período':
        this.saveNovedadesPeriodo(registro, indice);
        break;
      case 'Estado Nómina':
        this.saveEstadoNomina(registro, indice);
        break;
      case 'Nóminas Especiales':
        this.saveNominasEspeciales(registro, indice); 
        break;
      case 'Indemnización':
        this.saveIndemnizacion(registro, indice); 
        break;
      case 'Horarios de Trabajo':
        this.saveHorariosTrabajo(registro, indice); 
        break;
      case 'Novedades Tiempos':
        this.saveNovedadesTiempos(registro, indice); 
        break;
      case 'Ausentismos':
        this.saveAusentismos(registro, indice); 
        break;
      case 'Contingentes':
        this.saveContingentes(registro, indice); 
        break;
      default: 
        break;
    }
  }

  // #region grabaciones
  saveDireccion(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let paisID = 0;
    let provinciaID = 0;
    let claseID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.paisesList.findIndex(i => i.codigo == registro.pais);
    if (index != -1 ) paisID = this.paisesList[index].id;
    index = this.provinciasList.findIndex(i => i.codigo == registro.provincia);
    if (index != -1 ) provinciaID = this.provinciasList[index].id;
    index = this.clasesDireccionList.findIndex(i => i.codigo == registro.clase);
    if (index != -1 ) claseID = this.clasesDireccionList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      clase: claseID,
      calle: registro.calle,
      nro: registro.nro,
      piso: registro.piso === null || registro.piso == undefined ? '' : registro.piso,
      dpto: registro.dpto === null || registro.dpto == undefined ? '' : registro.dpto,
      localidad: registro.localidad,
      provincia: provinciaID,
      codPos: registro.codpos,
      pais: paisID,
      telefono: registro.telefono,
      observaciones: registro.observaciones === null || registro.observaciones == undefined ? '' : registro.observaciones,
      coordenadas: '',
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false)
    }
    
    this.direccionesService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveFamiliares(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let claseID = 0;
    let paisID = 0;
    let sexoID = 0;  
    let nacionalidadID = 0;
    let claseDocumentoID = 0;
    let estadoCivilID = 0;

    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.clasesFamiliarList.findIndex(i => i.codigo == registro.claseFamilia);
    if (index != -1 ) claseID = this.clasesFamiliarList[index].id;
    index = this.paisesList.findIndex(i => i.codigo == registro.pais);
    if (index != -1 ) paisID = this.paisesList[index].id;
    index = this.sexosList.findIndex(i => i.codigo == registro.sexo);
    if (index != -1 ) sexoID = this.sexosList[index].id;
    index = this.nacionalidadesList.findIndex(i => i.codigo == registro.nacionalidad);
    if (index != -1 ) nacionalidadID = this.nacionalidadesList[index].id;
    index = this.clasesDocList.findIndex(i => i.codigo == registro.claseDocumento);
    if (index != -1 ) claseDocumentoID = this.clasesDocList[index].id;
    index = this.estadoCivilList.findIndex(i => i.codigo == registro.estadoCivil);
    if (index != -1 ) estadoCivilID = this.estadoCivilList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      claseFamilia: claseID,
      nombre: registro.nombre,
      apellido: registro.apellido,
      segundoApellido: registro.segundoApellido === null || registro.segundoApellido == undefined ? '' : registro.segundoApellido,
      sexo: sexoID,
      nacionalidad: nacionalidadID,
      claseDocumento: claseDocumentoID,
      docNro: registro.docNro,
      fechaNacimiento: this.momentService.saveDateServer(registro.fechaNacimiento, false),
      pais: paisID,
      estadoCivil: estadoCivilID,
      celular: registro.celular,
      email: registro.email,
      discapacitado: registro.discapacitado === null || registro.discapacitado == undefined ? 'false' : registro.discapacitado,
      contactoEmergencia: registro.contactoEmergencia === null || registro.contactoEmergencia == undefined ? 'false' : registro.contactoEmergencia,
      presentacionCertificado: registro.presentacionCertificado === null || registro.presentacionCertificado == undefined ? '' : this.momentService.saveDateServer(registro.presentacionCertificado, false),
      lugar: '',
      lugarNacimiento: '',
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false)
    }
    
    this.familiaresService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveInfoIdentidad(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let claseID = 0;
    let paisID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.clasesDocList.findIndex(i => i.codigo == registro.claseDocumento);
    if (index != -1 ) claseID = this.clasesDocList[index].id;
    index = this.paisesList.findIndex(i => i.codigo == registro.paisEmisor);
    if (index != -1 ) paisID = this.paisesList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      claseDocumento: claseID,
      docNro: registro.docNro,
      fechaEmision: this.momentService.saveDateServer(registro.fechaEmision, false), 
      fechaValidez: this.momentService.saveDateServer(registro.fechaValidez, false),
      lugarEmision: registro.lugarEmision,
      nroEmision: registro.nroEmision,
      paisEmisor: paisID,
      autoridad: registro.autoridad,
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false)
    }
    
    this.infoIdentidadService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveDatosFechas(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let claseID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.clasesFechaList.findIndex(i => i.codigo == registro.claseFecha);
    if (index != -1 ) claseID = this.clasesFechaList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      claseFecha: claseID,
      fechaEvento: this.momentService.saveDateServer(registro.fechaEvento, false), 
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false)
    }
    
    this.datosFechasService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveAfiliaciones(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let claseID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.clasesAfiliacionList.findIndex(i => i.codigo == registro.claseAfiliaciones);
    if (index != -1 ) claseID = this.clasesAfiliacionList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      claseAfiliaciones: claseID,
      descripcion: registro.descripcion,
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false)
    }
    
    this.afiliacionesService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveContratos(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let claseID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.clasesContratosList.findIndex(i => i.codigo == registro.claseContrato);
    if (index != -1 ) claseID = this.clasesContratosList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      claseContrato: claseID,
      fechafinC: this.momentService.saveDateServer(registro.fechafinC, false),
      fechaFinPrueba: this.momentService.saveDateServer(registro.fechaFinPrueba, false),
      periodoPrueba: registro.periodoPrueba,
      horasMensuales: registro.horasMensuales,
      horasJornadaLaboral: registro.horasJornadaLaboral,
      desc: '',
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false)
    }
    
    this.contratosService.save(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveDatosBancarios(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let bancoID = 0;
    let viaPagoID = 0;
    let monedaID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.bancoList.findIndex(i => i.codigo == registro.banco);
    if (index != -1 ) bancoID = this.bancoList[index].id;
    index = this.pagoList.findIndex(i => i.codigo == registro.viaPago);
    if (index != -1 ) viaPagoID = this.pagoList[index].id;
    index = this.monedasList.findIndex(i => i.codigo == registro.moneda);
    if (index != -1 ) monedaID = this.monedasList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      banco: bancoID,
      cbu: registro.cbu,
      cuentaBancaria: registro.cuentaBancaria,
      viaPago: viaPagoID,
      moneda: monedaID,
      alias: '',
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false)
    }
    
    this.datosBancoService.save(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveSueldoBasico(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let estructuraID = 0;
    let nivelID = 0;
    let subNivelID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.estructuraSalariales.findIndex(i => i.codigo == registro.estructuraSalarialId);
    if (index != -1 ) estructuraID = this.estructuraSalariales[index].id;
    index = this.nivelList.findIndex(i => i.codigo == registro.nivel);
    if (index != -1 ) nivelID = this.nivelList[index].id;
    index = this.subnivelList.findIndex(i => i.codigo == registro.subNivel);
    if (index != -1 ) subNivelID = this.subnivelList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      estructuraSalarialId: estructuraID,
      nivel: nivelID,
      subNivel: subNivelID,
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false),
      sueldoBasicoConcepto: []
    }
    
    this.sueldoBasicoService.save(winsert, [], false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveNovedadesFijas(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let codigosNominaID = 0;
    let unidadMedidaID = 0;
    let monedaID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.codigoNominaList.findIndex(i => i.codigo == registro.codigosNomina);
    if (index != -1 ) 
    {
      codigosNominaID = this.codigoNominaList[index].id;
      unidadMedidaID = this.codigoNominaList[index].um;
    }
    if (registro.moneda != null && registro.moneda != undefined)
    {
      index = this.monedasList.findIndex(i => i.codigo == registro.moneda);
      if (index != -1 ) monedaID = this.monedasList[index].id;
    }
    
    let winsert = {
      id: 0,
      personal: personalID,
      codigosNomina: codigosNominaID,
      motivo: registro.motivo === null || registro.motivo == undefined ? '' : registro.motivo,
      quincena: registro.quincena === null || registro.quincena == undefined ? '' : registro.quincena,
      cantidad: registro.cantidad === null || registro.cantidad == undefined || registro.cantidad == '' ? 0 : registro.cantidad,
      importe: registro.importe === null || registro.importe == undefined || registro.importe == '' ? 0 : registro.importe,
      moneda: monedaID == 0 ? 1 : monedaID,
      unidadMedida: unidadMedidaID,
      fecha: this.momentService.saveDateServer(registro.fecha, false)
    }
    
    this.novedadesFijasService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveNovedadesPeriodo(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let codigosNominaID = 0;
    let unidadMedidaID = 0;
    let monedaID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.codigoNominaList.findIndex(i => i.codigo == registro.codigoNomina);
    if (index != -1 ) 
    {
      codigosNominaID = this.codigoNominaList[index].id;
      unidadMedidaID = this.codigoNominaList[index].um;
    }
    if (registro.moneda != null && registro.moneda != undefined)
    {
      index = this.monedasList.findIndex(i => i.codigo == registro.moneda);
      if (index != -1 ) monedaID = this.monedasList[index].id;
    }
    
    let winsert = {
      id: 0,
      personal: personalID,
      codigoNomina: codigosNominaID,
      motivo: registro.motivo === null || registro.motivo == undefined ? '' : registro.motivo,
      cantidad: registro.cantidad === null || registro.cantidad == undefined || registro.cantidad == '' ? 0 : registro.cantidad,
      importe: registro.importe === null || registro.importe == undefined || registro.importe == '' ? 0 : registro.importe,
      moneda: monedaID == 0 ? 1 : monedaID,
      unidadMedida: unidadMedidaID,
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false)
    }
    
    this.novedadesPeriodoService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveEstadoNomina(registro, indice) : void
  {
    let winsert = {
      legajo: registro.personal,
      bloqueado: registro.bloqueado,
      ultimaLiquidacion: this.momentService.saveDateServer(registro.ultimaLiquidacion, false),
      retroactividad: this.momentService.saveDateServer(registro.retroactividad, false),
      liquidarDesde: this.momentService.saveDateServer(registro.liquidarDesde, false),
      liquidarHasta: this.momentService.saveDateServer(registro.liquidarHasta, false)
    }
    
    this.personalService.SaveDatosEstadoNomina(winsert).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveNominasEspeciales(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let motivoNominaEspecialID = 0;
    let codigosNominaID = 0;
    let monedaID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.motivosList.findIndex(i => i.codigo == registro.motivoNominaEspecial);
    if (index != -1 ) motivoNominaEspecialID = this.motivosList[index].id;
    index = this.codigoNominaList.findIndex(i => i.codigo == registro.codigosNomina);
    if (index != -1 ) codigosNominaID = this.codigoNominaList[index].id;
    if (registro.moneda != null && registro.moneda != undefined)
    {
      index = this.monedasList.findIndex(i => i.codigo == registro.moneda);
      if (index != -1 ) monedaID = this.monedasList[index].id;
    }
    
    let winsert = {
      id: 0,
      personal: personalID,
      motivoNominaEspecial: motivoNominaEspecialID,
      codigosNomina: codigosNominaID,
      cantidad: registro.cantidad === null || registro.cantidad == undefined || registro.cantidad == '' ? 0 : registro.cantidad,
      importe: registro.importe === null || registro.importe == undefined || registro.importe == '' ? 0 : registro.importe,
      moneda: monedaID == 0 ? 1 : monedaID,
      fecha: this.momentService.saveDateServer(registro.fecha, false)
    }
    
    this.nominasEspecialesService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveIndemnizacion(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let motivoBajaID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.motivosBajaList.findIndex(i => i.codigo == registro.motivoBaja);
    if (index != -1 ) motivoBajaID = this.motivosBajaList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      motivoBaja: motivoBajaID,
      fecha: this.momentService.saveDateServer(registro.fecha, false),
      indemnizacionConcepto: []
    }
    
    this.indemnizacionService.save(winsert, [], false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveHorariosTrabajo(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let reglaID = 0;
    let horasDeTrabajoPorDia;
    let horasDeTrabajoPorSemana;
    let horasDeTrabajoPorMes;
    let horasDeTrabajoPorAnio;
    let diasLaboralesSemanal;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.reglasList.findIndex(i => i.codigo == registro.reglaHt);
    if (index != -1 ) 
    {
      reglaID = this.reglasList[index].id;
      horasDeTrabajoPorDia = this.reglasList[index].horasDeTrabajoPorDia;
      horasDeTrabajoPorSemana = this.reglasList[index].horasDeTrabajoPorSemana;
      horasDeTrabajoPorMes = this.reglasList[index].horasDeTrabajoPorMes;
      horasDeTrabajoPorAnio = this.reglasList[index].horasDeTrabajoPorAnio;
      diasLaboralesSemanal = this.reglasList[index].diasLaboralesSemanal;
    }
    
    let winsert = {
      id: 0,
      personal: personalID,
      reglaHt: reglaID,
      porcentajeAsignacion: registro.porcentajeAsignacion,
      hsTrabajoDiario: horasDeTrabajoPorDia,
      hsTrabSemana: horasDeTrabajoPorSemana,
      hsTrabMes: horasDeTrabajoPorMes,
      hsTrabAnio: horasDeTrabajoPorAnio,
      diasLaboralSemana: diasLaboralesSemanal,
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false),
      tipoEvaluacion: registro.tipoEvaluacion
    }
    
    this.horariosTrabajoService.save(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveNovedadesTiempos(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let codigosNominaID = 0;
    let unidadMedidaID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.codigoNominaList.findIndex(i => i.codigo == registro.codigosNomina);
    if (index != -1 ) 
    {
      codigosNominaID = this.codigoNominaList[index].id;
      unidadMedidaID = this.codigoNominaList[index].um;
    }
    
    let winsert = {
      id: 0,
      personal: personalID,
      codigosNomina: codigosNominaID,
      motivo: registro.motivo === null || registro.motivo == undefined ? '' : registro.motivo,
      cantidad: registro.cantidad === null || registro.cantidad == undefined || registro.cantidad == '' ? 0 : registro.cantidad,
      importe: registro.importe === null || registro.importe == undefined || registro.importe == '' ? 0 : registro.importe,
      unidadMedida: unidadMedidaID,
      fecha: this.momentService.saveDateServer(registro.fecha, false)
    }
    
    this.novedadesTiempoService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  async saveAusentismos(registro, indice) : Promise<void>
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let claseID = 0;
    let codigoNominaID;
    let unidadTiempoID;
    let cant = 0;
    let consumo = 0;
    let tiempoD = '';
    let tiempoH = '';
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.claseAusentismoList.findIndex(i => i.codigo == registro.claseAusentismo);
    if (index != -1 ) 
    {
      claseID = this.claseAusentismoList[index].id;
      codigoNominaID = this.claseAusentismoList[index].codigoNomina;
      unidadTiempoID = this.claseAusentismoList[index].unidadTiempo;
      let desde = registro.desde.toDateString();
      let hasta = registro.hasta.toDateString();
      if (unidadTiempoID == 1 || unidadTiempoID == 2 || unidadTiempoID == 3)
      {
        if (unidadTiempoID == 3)
        {
          let horaD = String(new Date(registro.horaDesde).getHours()).padStart(2, '0'); // Agrega un cero si es necesario
          let horaH = String(new Date(registro.horaHasta).getHours()).padStart(2, '0'); // Agrega un cero si es necesario
          let minuD = String(new Date(registro.horaDesde).getMinutes()).padStart(2, '0'); // Agrega un cero si es necesario
          let minuH = String(new Date(registro.horaHasta).getMinutes()).padStart(2, '0'); // Agrega un cero si es necesario
          tiempoD = horaD + ":" + minuD + ":00";
          tiempoH = horaH + ":" + minuH + ":00";
          
          desde = this.momentService.saveDateServer(new Date(desde + " " + tiempoD), true);
          hasta = this.momentService.saveDateServer(new Date(hasta + " " + tiempoH), true);
        }
        else
        {
          desde = this.momentService.saveDateServer(new Date(desde + " 00:00:00"), true);
          hasta = this.momentService.saveDateServer(new Date(hasta + " 00:00:00"), true);
        }
        const data = await this.unidadesTiempoService.calcularTiempoByUnidad(unidadTiempoID, desde, hasta, personalID).toPromise();
        cant = data;
        if (this.claseAusentismoList[index].claseContingente != null) consumo = cant;
      }
    }
    
    let winsert = {
      id: 0,
      personal: personalID,
      claseAusentismo: claseID,
      codigoNomina: codigoNominaID,
      unidadTiempo: unidadTiempoID,
      cantidad: cant,
      consumoContingente: consumo,
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false),
      horaDesde: tiempoD,
      horaHasta: tiempoH
    }
    
    this.ausentismosService.guardar(winsert).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveContingentes(registro, indice) : void
  {
    let index;

    //busco los Ids
    let personalID = 0;
    let claseID = 0;
    index = this.personalList.findIndex(i => i.code == registro.personal);
    if (index != -1 ) personalID = this.personalList[index].id;
    index = this.claseContingenteList.findIndex(i => i.codigo == registro.claseContingente);
    if (index != -1 ) claseID = this.claseContingenteList[index].id;
    
    let winsert = {
      id: 0,
      personal: personalID,
      claseContingente: claseID,
      inicioLiquidacion: this.momentService.saveDateServer(registro.inicioLiquidacion, false),
      finLiquidacion: this.momentService.saveDateServer(registro.finLiquidacion, false),
      cantidad: registro.cantidad,
      cantidadConsumida: 0,
      desde: this.momentService.saveDateServer(registro.desde, false),
      hasta: this.momentService.saveDateServer(registro.hasta, false)
    }
    
    this.contingentesService.guardar(winsert, false).subscribe(
      reg =>
      {
        this.registros[indice].errores.push("OK");
      },
      error =>
      {
        this.verError(error, indice);
      });    
  }
  saveHistorial(registros) : void
  {
    this.liquidacionSrv.saveHistorial(registros).subscribe(
      reg =>
      {
        this.registros = reg;
      },
      error =>
      {
        this.verError(error, 1);
      });      
    
  }

  // #endregion

  verError(error, indice) : void
  {
    if (error.status == 400)
    {
      this.registros[indice].errores.push("ERROR: " + this.erroresService.MostrarError400(error));
    }
    else
    {
      this.registros[indice].errores.push("ERROR");
    }
  }
}
    